import { ConfirmDialog } from '@/components/common/ConfirmDialog';
import { useDeleteLeaveType } from '../hooks/useDeleteLeaveType';
import type { LeaveType } from '../types/leaveType.types';

interface LeaveTypeDeleteConfirmationProps {
  leaveType: LeaveType | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function LeaveTypeDeleteConfirmation({
  leaveType,
  open,
  onOpenChange,
}: LeaveTypeDeleteConfirmationProps) {
  const { mutate, isPending } = useDeleteLeaveType();

  function handleConfirm() {
    if (!leaveType) return;
    mutate(leaveType.id, { onSuccess: () => onOpenChange(false) });
  }

  const description = leaveType
    ? `"${leaveType.name}" will be removed. A leave type already used by leave applications can't be deleted - set its status to Inactive instead.`
    : '';

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Delete leave type?"
      description={description}
      confirmLabel="Delete"
      confirmVariant="destructive"
      isPending={isPending}
      pendingLabel="Deleting..."
      onConfirm={handleConfirm}
    />
  );
}
